module.exports = __webpack_public_path__ + "static/media/reviews-illustration.6c93ea02.png";